import { render, staticRenderFns } from "./QuoteWidget.vue?vue&type=template&id=708248bc&scoped=true"
import script from "./QuoteWidget.vue?vue&type=script&lang=js"
export * from "./QuoteWidget.vue?vue&type=script&lang=js"
import style0 from "./QuoteWidget.vue?vue&type=style&index=0&id=708248bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708248bc",
  null
  
)

export default component.exports